import authApi from './libs/auth';
import adminApi from './libs/admin';
import membershipApi from './libs/membership';
import consumeSettingApi from './libs/consume-setting';
import internalSettingApi from './libs/internal-setting';
import orderApi from './libs/order';
import advertisementApi from './libs/advertisement';
import crowdfundApi from './libs/crowdfund';
import investmentApi from './libs/investment';
import notificationApi from './libs/notification';

export const commonsApi = {
    // Auth
    login: authApi.login,

    // Admin
    me: adminApi.me,
    invite: adminApi.invite,
    adminIndex: adminApi.index,
    adminShow: adminApi.show,
    adminUpdate: adminApi.update,
    adminDelete: adminApi.delete,
    resentInvitation: adminApi.resentInvitation,
    activation: adminApi.activation,
    requestResetPassword: adminApi.requestResetPassword,
    resetPassword: adminApi.resetPassword,
    forceResetPassword: adminApi.forceResetPassword,

    // Admin Roles
    adminRoleIndex: adminApi.roleIndex,
    adminResourceIndex: adminApi.resourceIndex,
    adminRolePermissionIndex: adminApi.rolePermissionIndex,

    // Membership
    membershipIndex: membershipApi.index,
    membershipShow: membershipApi.show,
    membershipCreate: membershipApi.create,
    membershipUpdate: membershipApi.update,
    membershipDelete: membershipApi.delete,

    // Setting
    consumeSettingShow: consumeSettingApi.show,
    consumeSettingUpdate: consumeSettingApi.update,
    internalSettingShow: internalSettingApi.show,
    internalSettingUpdate: internalSettingApi.update,

    // Order
    orderIndex: orderApi.index,
    orderShow: orderApi.show,
    orderForceConfirm: orderApi.forceConfirm,
    orderVerify: orderApi.verify,
    orderRefund: orderApi.refund,
    orderDeny: orderApi.deny,

    // Advertisement
    advertisementIndex: advertisementApi.index,
    advertisementShow: advertisementApi.show,
    advertisementCreatePropertyAd: advertisementApi.createPropertyAd,
    advertisementCreateProjectAd: advertisementApi.createProjectAd,
    advertisementVerify: advertisementApi.verify,
    advertisementDeny: advertisementApi.deny,

    // Crowdfund
    crowdfundIndex: crowdfundApi.index,
    crowdfundShow: crowdfundApi.show,
    crowdfundUpdate: crowdfundApi.update,
    crowdfundDeny: crowdfundApi.deny,
    crowdfundStartCrowdfunding: crowdfundApi.startCrowdfunding,
    crowdfundLockdown: crowdfundApi.lockdown,
    crowdfundFinish: crowdfundApi.finish,
    crowdfundForceConfirm: crowdfundApi.forceConfirm,
    crowdfundCreate: crowdfundApi.create,
    crowdfundAdvertiseWithProperty: crowdfundApi.advertiseWithProperty,
    crowdfundAdvertiseWithProject: crowdfundApi.advertiseWithProject,

    // Investment
    investmentIndex: investmentApi.index,

    // Notification
    notificationBroadcast: notificationApi.broadcast
};

export default commonsApi;
